import { DateStepper } from "components/DateStepper";
import { Dayjs } from "dayjs";
import { useState } from "react";
import { useTargetedReviewMonthIndicators } from "./useTargetedReviewMonthIndicators";

export const TargetedReviewDateStepper = ({
  location,
  selectedDate,
  setSelectedDate,
}: {
  location: string;
  selectedDate: Dayjs;
  setSelectedDate: (date: Dayjs) => void;
}) => {
  const [viewedMonth, setViewedMonth] = useState<Dayjs>(selectedDate);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const { indicators, isFetching, isError } = useTargetedReviewMonthIndicators({
    location,
    month: viewedMonth,
    enabled: isCalendarOpen,
  });
  return (
    <DateStepper
      date={selectedDate}
      setDate={setSelectedDate}
      dayIndicators={indicators}
      indicatorsLoading={isFetching}
      indicatorsError={isError}
      onCalendarOpenChange={(open) => {
        if (open) setViewedMonth(selectedDate);
        setIsCalendarOpen(open);
      }}
      onMonthChange={setViewedMonth}
      timezone="UTC"
    />
  );
};
